/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { authClientsListMcpServerChoices } from "../funcs/authClientsListMcpServerChoices.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListMcpServerAuthClientChoicesResponseBody } from "../models/components/listmcpserverauthclientchoicesresponsebody.js";
import {
  ListMcpServerAuthClientChoicesRequest,
  ListMcpServerAuthClientChoicesSecurity,
} from "../models/operations/listmcpserverauthclientchoices.js";
import { unwrapAsync } from "../types/fp.js";
export type McpServerAuthClientChoicesQueryData =
  ListMcpServerAuthClientChoicesResponseBody;

export function prefetchMcpServerAuthClientChoices(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListMcpServerAuthClientChoicesRequest,
  security?: ListMcpServerAuthClientChoicesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildMcpServerAuthClientChoicesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildMcpServerAuthClientChoicesQuery(
  client$: GramCore,
  request: ListMcpServerAuthClientChoicesRequest,
  security?: ListMcpServerAuthClientChoicesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<McpServerAuthClientChoicesQueryData>;
} {
  return {
    queryKey: queryKeyMcpServerAuthClientChoices({
      mcpServerId: request.mcpServerId,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
    }),
    queryFn: async function mcpServerAuthClientChoicesQueryFn(
      ctx,
    ): Promise<McpServerAuthClientChoicesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(authClientsListMcpServerChoices(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyMcpServerAuthClientChoices(
  parameters: {
    mcpServerId: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "authClients", "listMcpServerChoices", parameters];
}
